import { defineStore } from 'pinia';
import { ref } from 'vue';

export interface Toast {
  id: string;
  message: string;
  type: 'success' | 'warning' | 'error';
  duration?: number;
}

export const useToastStore = defineStore('toast', () => {
  const toasts = ref<Toast[]>([]);

  function addToast(toast: Omit<Toast, 'id'>) {
    const id = Math.random().toString(36).substring(2, 9);
    const duration = toast.duration || 5000;

    toasts.value.push({ ...toast, id });

    // 自動移除 toast
    setTimeout(() => {
      removeToast(id);
    }, duration);
  }

  function removeToast(id: string) {
    toasts.value = toasts.value.filter((toast) => toast.id !== id);
  }

  // 便捷方法
  function success(message: string, duration?: number) {
    addToast({ message, type: 'success', duration });
  }

  function warning(message: string, duration?: number) {
    addToast({ message, type: 'warning', duration });
  }

  function error(message: string, duration?: number) {
    addToast({ message, type: 'error', duration });
  }

  const reset = () => {
    toasts.value = [];
  };

  return {
    toasts,
    addToast,
    removeToast,
    success,
    warning,
    error,
    reset,
  };
});
